export const PartStatus = {
  PENDING: 'Pending',
  REQUESTED: 'Requested',
  ORDERED: 'Ordered',
  RECEIVED: 'Received',
  RETURNED: 'Returned',
  AWAITING_RETURN: 'Awaiting Return',
} as const;

export type PartStatus = keyof typeof PartStatus;
